import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const navigate = useNavigate();
  const { signIn, userProfile } = useAuth();

  // Redirect when userProfile is loaded after successful login
  useEffect(() => {
    if (shouldRedirect && userProfile) {
      if (userProfile.is_admin) {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    }
  }, [shouldRedirect, userProfile, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }

    setIsLoading(true);

    const { error: signInError } = await signIn(email, password);

    if (signInError) {
      setError(signInError.message);
      setIsLoading(false);
    } else {
      // Set flag to redirect once userProfile is loaded
      setShouldRedirect(true);
    }
  };

  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      background: 'linear-gradient(135deg, #0A0D12 0%, #252B37 100%)',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#FFFFFF'
    }}>
      <div style={{
        background: '#FFFFFF',
        borderRadius: '16px',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '420px',
        boxShadow: '0 20px 40px rgba(10, 13, 18, 0.2)',
        position: 'relative',
        overflow: 'hidden',
        border: '3px solid transparent',
        backgroundClip: 'padding-box',
        animation: 'slideUp 0.6s ease-out'
      }}>
        <style>{`
          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .login-container::before {
            content: '';
            position: absolute;
            top: -3px;
            left: -3px;
            right: -3px;
            bottom: -3px;
            background: linear-gradient(135deg, #FF642C 0%, rgba(255, 100, 44, 0.6) 25%, rgba(255, 100, 44, 0.3) 50%, rgba(255, 100, 44, 0.6) 75%, #FF642C 100%);
            border-radius: 19px;
            z-index: -1;
          }
        `}</style>

        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ color: '#0A0D12', fontSize: '28px', fontWeight: '700', marginBottom: '4px' }}>
            Restoke
          </div>
          <div style={{ color: '#FF642C', fontSize: '14px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Office Attendance Dashboard
          </div>
        </div>

        {error && (
          <div style={{
            background: '#FEE2E2',
            border: '1px solid #EF4444',
            color: '#991B1B',
            padding: '12px 16px',
            borderRadius: '8px',
            fontSize: '14px',
            marginBottom: '16px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ color: '#535862', fontSize: '14px', fontWeight: '500', marginBottom: '8px' }} htmlFor="email">
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{
                padding: '16px',
                border: '2px solid #E9EAEB',
                borderRadius: '8px',
                fontSize: '16px',
                color: '#0A0D12',
                background: '#FAFAFA',
                transition: 'all 0.2s ease'
              }}
              placeholder="Enter your email address"
              required
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label style={{ color: '#535862', fontSize: '14px', fontWeight: '500', marginBottom: '8px' }} htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                padding: '16px',
                border: '2px solid #E9EAEB',
                borderRadius: '8px',
                fontSize: '16px',
                color: '#0A0D12',
                background: '#FAFAFA',
                transition: 'all 0.2s ease'
              }}
              placeholder="Enter your password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            style={{
              background: 'linear-gradient(135deg, #FF642C 0%, #0A0D12 100%)',
              color: '#FFFFFF',
              border: 'none',
              padding: '16px 24px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s ease',
              marginTop: '16px'
            }}
          >
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={{
          textAlign: 'center',
          color: '#717680',
          fontSize: '12px',
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid #E9EAEB'
        }}>
          Secure access to your attendance dashboard
        </div>
      </div>
    </div>
  );
}

export default Login;
